import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';

const RedirectToPartnerAdmin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('business_token');

    if (token) {
      try {
        // Decode the token to extract clientType and other details
        const decodedToken = jwtDecode(token);
        console.log('Decoded Business Token:', decodedToken);

        const { clientType, clientId, venue, event, temple, orgId, orgName } = decodedToken;

        // Redirect based on clientType
        switch (clientType) {
          case 'venue':
            navigate(`/partner/admin/venue/${clientId}/${venue}`);
            break;
          case 'event':
            navigate(`/partner/admin/event/${clientId}/${event}`);
            break;
          case 'temple':
            navigate(`/partner/admin/temple/${clientId}/${temple}`);
            break;
          case 'organization':
            navigate(`/partner/admin/org/${orgId}/${orgName}`);
            break;
          default:
            console.error('Unknown clientType:', clientType);
        }
      } catch (error) {
        console.error('Error decoding token:', error);
        // Optionally navigate to a fallback or error page
        navigate('/partner/admin');
      }
    } else {
      // If no token, redirect to login or an error page
      navigate('/partner/admin');
    }
  }, [navigate]);

  return <div>Loading...</div>; // Placeholder while redirecting
};

export default RedirectToPartnerAdmin;
